<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <custom-dialog-content
      :cancel="cancel"
      :form-def="formDef"
      :message="message"
      :ok="ok"
      :title="title"
      :values="values"
      @onCancelClick="onDialogCancel"
      @onOKClick="onOKClick"
    ></custom-dialog-content>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from "quasar";
import CustomDialogContent from "./CustomDialogContent.vue";
import { ref, onMounted } from "vue";
const props = defineProps({
  cancel: {
    type: [String, Object, Boolean],
  },
  defaultValues: Object,
  formDef: Object,
  message: String,
  ok: {
    type: [String, Object, Boolean],
  },
  title: String,
});

const values = ref({});

onMounted(() => {
  // Definir os valores iniciais dos campos do formulário
  if (props.defaultValues) values.value = { ...props.defaultValues };
});

defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits,
]);

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();
// dialogRef      - Vue ref to be applied to QDialog
// onDialogHide   - Function to be used as handler for @hide on QDialog
// onDialogOK     - Function to call to settle dialog with "ok" outcome
//                    example: onDialogOK() - no payload
//                    example: onDialogOK({ /*...*/ }) - with payload
// onDialogCancel - Function to call to settle dialog with "cancel" outcome

function onOKClick() {
  // Salvar os valores atuais na localStorage
  // Chamar onDialogOK() para resolver o diálogo com o resultado "ok"
  onDialogOK(values.value);
  // ou, se preferir, passar os valores diretamente
  // onDialogOK({ ...values.value });
}
</script>
